'use client';
import { useCallback, useEffect } from 'react';
import { useYmm20 } from '@/hooks/useYmm';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import styles from './navYmm.module.scss';

const YMM_OPEN_EVENT = 'sxm:ymm:open';

export default function NavYMM() {
    const { ymmTextBar, modal, getYears } = useYmm20();
    const showYmmModal = useCallback(() => {
        document.querySelector('html')?.classList.add('showYmm');
        getYears();
    }, [getYears]);

    useEffect(() => {
        const handler = () => {
            showYmmModal();
        };

        window.addEventListener(YMM_OPEN_EVENT, handler as EventListener);
        return () => window.removeEventListener(YMM_OPEN_EVENT, handler as EventListener);
    }, [showYmmModal]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const showFromUrl = params.get('ymm') === 'true';

        if (showFromUrl) {
            showYmmModal();
        }
    }, [showYmmModal]);

    return (
        <>
            <Grid container className={styles.containerWrapper}>
                <Grid className={styles.container} col={{ sm: 12 }}>
                    <span className={styles.ymmTextWrapper} data-cy="nav_ymm-display">
                        Showing channels for my
                        <span className={styles.selection}> {ymmTextBar}</span>.{' '}
                        <button className={styles.editButton} onClick={() => showYmmModal()}>
                            Edit
                        </button>
                    </span>
                </Grid>
            </Grid>
            {modal}
        </>
    );
}
